const cards = [
  {
    title: '某顶流选手被曝即将转会，天价合同细节首次公开',
    desc: '知情人士透露合同总金额超千万级别，包含多项史无前例的附加条款，若属实将刷新行业纪录。',
    tag: '深度爆料',
    time: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Professional%20athlete%20contract%20signing%20scene%20with%20dramatic%20lighting%2C%20sports%20business%20theme%2C%20warm%20corporate%20atmosphere%2C%20editorial%20photography%20style%2C%20luxury%20office%20setting%20with%20documents&width=600&height=380&seq=card-01-51&orientation=landscape',
  },
  {
    title: '综艺节目录制现场突发状况，导演组被曝临时改规则',
    desc: '现场观众爆料称节目组在录制中途突然修改淘汰规则，引发参赛选手集体抗议，场面一度失控。',
    tag: '独家爆料',
    time: '4小时前',
    image: 'https://readdy.ai/api/search-image?query=TV%20production%20set%20with%20chaos%20and%20crew%20discussion%2C%20reality%20show%20behind%20scenes%2C%20warm%20studio%20lighting%2C%20dramatic%20documentary%20style%2C%20professional%20broadcast%20environment&width=600&height=380&seq=card-02-51&orientation=landscape',
  },
  {
    title: '游戏大厂内部邮件泄漏：新项目因资金问题或面临取消',
    desc: '匿名员工提供的内部邮件显示项目预算被大幅削减，开发团队人心惶惶，多个核心岗位已出现离职。',
    tag: '行业揭秘',
    time: '6小时前',
    image: 'https://readdy.ai/api/search-image?query=Corporate%20office%20with%20worried%20employees%20and%20email%20screens%2C%20game%20development%20studio%20atmosphere%2C%20warm%20office%20lighting%2C%20editorial%20business%20photography%2C%20serious%20meeting%20discussion&width=600&height=380&seq=card-03-51&orientation=landscape',
  },
  {
    title: '音乐节门票被曝内部预留过半，主办方面临诚信危机',
    desc: '多名购票失败的粉丝联合发声，质疑官方售票系统存在暗箱操作，呼吁相关部门介入调查。',
    tag: '热门讨论',
    time: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20crowd%20with%20disappointed%20fans%2C%20concert%20ticketing%20theme%2C%20warm%20outdoor%20lighting%2C%20editorial%20event%20photography%2C%20large%20venue%20atmosphere%20with%20stage&width=600&height=380&seq=card-04-51&orientation=landscape',
  },
  {
    title: '体育赛事裁判被曝收取好处费，联盟宣布全面调查',
    desc: '匿名举报材料详细列举多场比赛中的争议判罚与后续利益输送，涉事裁判已被暂时停职接受审查。',
    tag: '重磅曝光',
    time: '10小时前',
    image: 'https://readdy.ai/api/search-image?query=Sports%20referee%20on%20field%20with%20investigation%20theme%2C%20controversial%20match%20atmosphere%2C%20warm%20stadium%20lighting%2C%20professional%20sports%20journalism%2C%20dramatic%20game%20moment%20composition&width=600&height=380&seq=card-05-51&orientation=landscape',
  },
  {
    title: '网红主播被实锤数据造假，平台连夜下架直播间',
    desc: '第三方监测数据显示该主播直播间90%以上为机器刷量，平台在舆论压力下紧急采取封禁措施。',
    tag: '打假揭露',
    time: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20with%20data%20analytics%20screens%2C%20influencer%20broadcasting%20theme%2C%20warm%20studio%20lighting%2C%20digital%20technology%20and%20social%20media%20visuals%2C%20modern%20content%20creation%20setup&width=600&height=380&seq=card-06-51&orientation=landscape',
  },
  {
    title: '51吃瓜爆料每日大赛：本周网友热评精选合集',
    desc: '汇集本周最具话题性的网友评论与深度分析，从路人视角看大赛背后的那些事儿，笑点与泪点齐飞。',
    tag: '精选合集',
    time: '14小时前',
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20comments%20collage%20with%20reaction%20emojis%2C%20online%20discussion%20theme%2C%20warm%20digital%20community%20atmosphere%2C%20editorial%20internet%20culture%20style%2C%20vibrant%20social%20engagement%20visuals&width=600&height=380&seq=card-07-51&orientation=landscape',
  },
];

export default function InfoCards() {
  return (
    <section id="cards" className="section-py bg-background-100">
      <div className="section-container">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            深度爆料
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer flex flex-col"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading leading-snug flex-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {cards.slice(3).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-300 transition-colors cursor-pointer flex flex-col"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading leading-snug flex-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}